import { IManutencaoConcluida } from "../../../Interfaces/AssistenciaTecnica/ManutencaoConcluida/ManutencaoConcluidaInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export function ManutencaoConcluidaService(data: IManutencaoConcluida) {
    return Service(
        Axios.post(
            `/assistenciatecnica/acaoatendimento/manutencaoconcluida`,
            data
        )
    );
}
